import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { fonts } from "./fonts2022";
export var normal = _objectSpread(_objectSpread({}, fonts["body-m"]), {}, {
  background: "var(--CDS-color-semantic-surface-default)",
  appearance: "none",
  border: "solid 1px var(--CDS-color-semantic-surface-foreground-subtle)",
  borderColor: "var(--CDS-color-semantic-surface-foreground-subtle)",
  borderRadius: "var(--CDS-border-radius-s)"
});
export var hover = {
  borderColor: "var(--CDS-color-semantic-surface-foreground-default)"
};
export var active = {
  outline: "none",
  border: "solid 1px var(--CDS-color-semantic-actions-default)"
};
export var focus = {
  outline: "2px solid var(--CDS-color-semantic-actions-default)",
  outlineOffset: 2,
  boxShadow: "none",
  borderColor: "var(--CDS-color-semantic-surface-foreground-default)"
};
export var focusWithin = _objectSpread(_objectSpread({}, focus), {}, {
  borderRadius: "var(--CDS-border-radius-s)",
  "input:focus-visible:focus": {
    outline: "none"
  }
});
export var disabled = {
  background: "var(--CDS-color-semantic-surface-default)",
  borderColor: "var(--CDS-color-semantic-surface-foreground-disabled)",
  color: "var(--CDS-color-semantic-surface-foreground-disabled)",
  cursor: "not-allowed"
};
export var invalid = {
  borderColor: "var(--CDS-color-semantic-feedback-critical-default)",
  color: "var(--CDS-color-semantic-feedback-critical-default)"
};
export var invalidHover = {
  borderColor: "var(--CDS-color-semantic-feedback-critical-default)",
  color: "var(--CDS-color-semantic-feedback-critical-default)"
};